var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G } from "react-native-svg";
function SvgRaces(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z",
    fill: "#e1087e"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M15.3 8.4H9.7c-.3 0-.6.1-.8.2l-1.7 1c-.3.2-.6.5-.6.9l-2 7.8c-.1.4.2.8.6.9l2 .4 1.7-6.4.7 6.6h5.9l.7-6.6 1.7 6.4 2-.4c.4-.1.7-.5.6-.9l-2-7.8c-.1-.4-.3-.7-.6-.9l-1.7-.9c-.3-.2-.6-.3-.9-.3zM6.6 18.7l-1.4-.2 2-7.9c0-.2.2-.3.3-.4l1.7-.9c.1-.1.3-.1.4-.1h5.6c.1 0 .3 0 .4.1l1.7.9c.2.1.3.3.3.5l2 7.8-1.4.3-1.3-5.8c-.1-.3-.4-.5-.7-.5-.4 0-.6.3-.7.6l-.7 6h-4.6l-.7-6c0-.3-.3-.6-.7-.6-.3 0-.6.2-.7.5l-1.5 5.7zM12.5 3.7c-1.9 0-2.8 1.4-2.8 3.2h5.6c0-1.8-.8-3.2-2.8-3.2zm-2 2.5c.1-.8.6-1.7 2-1.7s1.8.9 2 1.7h-4z"
  }))));
}
export default SvgRaces;